import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import ProjectSubmissionDetail from '../../components/project_submission/ProjectSubmissionDetail';
import {
  createProjectSubmission,
  editProjectSubmission,
  deleteProjectSubmission,
  submitProjectSubmission,
} from '../../redux/project_inspection/project_inspection_actions';

import { defaultRejectHandler } from '../../utils/utility';

class ProjectSubmissionModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.submissionDetailRef = null;
  }

  onDeleteHandler() {
    this.props.deleteSubmission(this.props.submissionDetail.id);
  }

  onSaveHandler() {
    const editedSubmission = this.submissionDetailRef.getWrappedInstance().getWrappedInstance().getSubmissionData();
    this.props.editSubmission({ ...editedSubmission, id: this.props.submissionDetail.id });
  }

  onSubmitHandler() {
    this.props.submitSubmission(this.props.submissionDetail.id);
  }

  componentDidUpdate(prevProps) {
    if (this.props.show) {
      const { submissionDetail } = this.props;
      if (!submissionDetail && !this.props.isCreating) {
        this.props.createSubmission();
      }
    }

    if (!this.props.isEditing && this.props.isEditing !== prevProps.isEditing && !this.props.errorMessage) {
      this.setState({ isSubmittable: false, isDirty: false });
    }
  }

  render() {
    const {
      isCreating,
      isEditing,
      isDeleting,
      isSubmitting,
      errorMessage,
      submissionDetail,
      t,
      ...newProps
    } = this.props;
    const { isSubmittable, isDirty } = this.state;
    const isInProgress = isCreating || isEditing || isDeleting || isSubmitting;

    return (
      <Modal
        {...newProps}
        backdrop="static"
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
      >
        <Modal.Header>
          <Modal.Title>
            {t('project submission')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isCreating
            ? <p>{t('loading')}</p>
            : <ProjectSubmissionDetail
              submission={submissionDetail}
              onValid={isValid => this.setState({ isValid })}
              onDirty={isDirty => this.setState({ isDirty })}
              onSubmittable={isSubmittable => this.setState({ isSubmittable })}
              fieldErrors={errorMessage}
              ref={ref => (this.submissionDetailRef = ref)}
              t={t}
            />
          }
        </Modal.Body>
        <Modal.Footer>
          <div className="project-submission-control-box">
            <div className="left-box">
              <Button
                id="project-submission-delete"
                bsStyle="danger"
                disabled={isInProgress}
                onClick={() => this.onDeleteHandler()}
              >
                {isDeleting ? `${t('deleting')}...` : t('delete')}
              </Button>
            </div>
            <div className="right-box">
              <Button
                id="project-submission-submit"
                style={{ width: 140 }}
                bsStyle="success"
                disabled={isInProgress || !(submissionDetail && submissionDetail.description) || isDirty}
                onClick={() => this.onSubmitHandler()}
              >
                {isSubmitting ? `${t('submitting')}...` : t('submit to review')}
              </Button>
              <Button
                id="project-submission-edit"
                bsStyle="primary"
                disabled={!isSubmittable || isInProgress}
                onClick={() => this.onSaveHandler()}
              >
                {isEditing ? `${t('saving')}...` : t('save')}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, { project }) => ({
  isCreating: state.projectInspection.isCreating,
  isEditing: state.projectInspection.isEditing,
  isDeleting: state.projectInspection.isDeleting,
  isSubmitting: state.projectInspection.isSubmitting,
  errorMessage: state.projectInspection.errorMessage,
});

const mapDispatchToProps = (dispatch, { project }) => ({
  createSubmission: () => defaultRejectHandler(dispatch(createProjectSubmission(project.id, project.name, ''))),
  editSubmission: ({ id, description }) => defaultRejectHandler(dispatch(editProjectSubmission(id, project.name, description))),
  deleteSubmission: (id) => defaultRejectHandler(dispatch(deleteProjectSubmission(id))),
  submitSubmission: (id) => defaultRejectHandler(dispatch(submitProjectSubmission(id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ProjectSubmissionModal),
);



// WEBPACK FOOTER //
// ./src/modal/project_submission/ProjectSubmissionModal.js